import { render, staticRenderFns } from "./EditionAttachments.vue?vue&type=template&id=2783923a&scoped=true"
import script from "./EditionAttachments.vue?vue&type=script&lang=js"
export * from "./EditionAttachments.vue?vue&type=script&lang=js"
import style0 from "./EditionAttachments.vue?vue&type=style&index=0&id=2783923a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2783923a",
  null
  
)

export default component.exports